/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FreshserviceBudgetAlertsMapping extends models.FreshserviceMappingBase {
    getFixupPrototypeFunction() { return FreshserviceBudgetAlertsMapping.fixupPrototype; }

    static newInstance(model: Partial<FreshserviceBudgetAlertsMapping>): FreshserviceBudgetAlertsMapping {
        let obj = Object.assign(new FreshserviceBudgetAlertsMapping(), model);
        FreshserviceBudgetAlertsMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FreshserviceBudgetAlertsMapping>): FreshserviceBudgetAlertsMapping {
        if (!model) return null;
        return FreshserviceBudgetAlertsMapping.newInstance(<FreshserviceBudgetAlertsMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FreshserviceBudgetAlertsMapping) {
        if (!obj) return;

        models.FreshserviceBudgetAlertsMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FreshserviceBudgetAlertsMapping): boolean {
        if (models.FreshserviceMappingBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FreshserviceBudgetAlertsMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.attribute_mappings) {
            for (let val of this.attribute_mappings) {
                models.FreshserviceIncidentConfigurationMappingForBudgetAlerts.fixupPrototype(val);
            }
        }
    }

    /**
     * List of Budget Alert attribute enums for Freshservice
     */
    description_attributes: Array<models.DescriptionAttributeForItsmBudgetAlert>;

    /**
     * List of Freshservice attribute mappings
     */
    attribute_mappings: Array<models.FreshserviceIncidentConfigurationMappingForBudgetAlerts>;

}
